
<template-base
    title          = "Signatur"
    :items         = "signatures"
    :variables     = "variables"
    :settings-admin = "isSettingsAdmin"
    :header-height = "355"
    @save          = "onSave"
    ref            = "base"
>
    <template v-slot:ident="data" >
        <v-row class="no-frame mt-0">
            <v-col class="no-frame col-12">
                <f-read-only-field
                    v-if   = "data.item.standard"
                    label  = "Name"
                    :value = "data.item.name"
                    style  = "margin-top: 5px"
                />
                <v-text-field
                    v-if="!data.item.standard"
                    label          = "Name"
                    v-model        = "data.item.name"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    :readonly      = "isSettingsAdmin"
                />
            </v-col>
        </v-row>
    </template>
</template-base>
